import React, { FC, memo, useMemo } from 'react'
import { Notice } from '@ucheba/ui/components/Notice/desktop'
import { Grid, GridCol } from '@ucheba/ui/components/Grid/desktop'
import Image from 'next/image'
import { Heading } from '@ucheba/ui/components/Heading/desktop'
import { Text } from '@ucheba/ui/components/Text/desktop'
import { Spacing } from '@ucheba/ui/components/Spacing/desktop'
import { Button } from '@ucheba/ui/components/Button/desktop'
import { successRegisterOnlineNotStartedEventNoticeId } from '../constans'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import noticeSuccessRegister from '../assets/img__notice_successRegister.png'
import data from '../data.json'
import { IEventsPageRegisterOnlineNotice } from '../types'

/** Нотис при успешной регистрации на мероприятие (не стартовавшее) */
const ProfMrathonRegisterNotStartedEventNotice: FC<IEventsPageRegisterOnlineNotice> = (
  props
) => {
  const { id, open, isHybrid, needVk, linkReg } = props
  const noticeNata = useMemo(() => data.successRegister.onlineLater, [])

  return (
    <Notice
      id={successRegisterOnlineNotStartedEventNoticeId + id}
      hideProgress
      open={open}
      color='blue'
      width='518px'
    >
      <Grid spacing='medium' nowrap alignItems='flex-end'>
        <GridCol width='auto' shrink='initial'>
          <Heading h3={noticeNata.title} spacing='xxsmall' />

          <Text>
            {!isHybrid
              ? `${noticeNata.description} ${needVk ? data.vk.text : ''}`
              : noticeNata.hybridDescription}
          </Text>

          {needVk && (
            <>
              <Spacing spacing='medium' />

              <Button color='gold' href={linkReg || data.vk.href}>
                {data.vk.buttonText}
              </Button>
            </>
          )}
        </GridCol>

        <GridCol width={`${84 + 16}px`}>
          <Image src={noticeSuccessRegister} alt='' width={84} height={84} />
        </GridCol>
      </Grid>
    </Notice>
  )
}

export default memo(ProfMrathonRegisterNotStartedEventNotice)
